import _ from "lodash";

import { AccountingsKpiEntity } from "../../entity/AccountingsKpiEntity";
import { HttpAdapter } from "../../main/adapters/HttpAdapter";

export class AccountingsKpiGateway {
    HttpAdapter = new HttpAdapter();
    baseUrl = `${publicSettings.aws.baseUrls.accounting}/accounting`;

    constructor({ PointsAccountingAnalytics } = {}) {
        this.PointsAccountingAnalytics = PointsAccountingAnalytics;
    }

    async getByYearAndMonth({ year, month }) {
        const isSandbox =
            publicSettings.environment === "development" ? true : false;

        if (isSandbox) {
            year = "2024";
            month = "12";
        }

        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/kpi/get-by-year-month`,
            { year, month }
        );

        return new AccountingsKpiEntity(response);
    }

    async getHistoricBillingByDate({
        start = { year, month },
        end = { year, month }
    }) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/kpi/get-historic-billing-by-date`,
            { date: { start, end } }
        );

        return new AccountingsKpiEntity(response);
    }

    async getHistoricScoreByDate({
        start = { year, month },
        end = { year, month }
    }) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/kpi/get-historic-score-by-date`,
            { date: { start, end } }
        );

        return new AccountingsKpiEntity(response);
    }

    async getHistoricImpactByDate({
        start = { year, month },
        end = { year, month }
    }) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/kpi/get-historic-impact-by-date`,
            { date: { start, end } }
        );

        return new AccountingsKpiEntity(response);
    }

    _modelerPointsScore({ data, s, valuePath } = {}) {
        const points = data.map((prop) => {
            return {
                t: new Date(prop.date),
                s,
                c: "EMPRESA_NUCONT",
                sc: "ORIGINAL",
                u: new Date(),
                a: "NUCONT",
                m: {
                    high: _.get(prop, `${valuePath}.high`, 0),
                    medium: _.get(prop, `${valuePath}.medium`, 0),
                    low: _.get(prop, `${valuePath}.low`, 0),
                    total: prop.result.total,
                    score: prop.result.score
                },
                period: "monthly"
            };
        });

        return _.sortBy(points, "t");
    }

    _modelerPointsImpact({ data, s, valuePath } = {}) {
        const points = data.map((prop) => {
            return {
                t: new Date(prop.date),
                s,
                c: "EMPRESA_NUCONT",
                sc: "ORIGINAL",
                u: new Date(),
                a: "NUCONT",
                m: {
                    Prata: _.get(prop, `${valuePath}.Prata`, 0),
                    Bronze: _.get(prop, `${valuePath}['Bronze']`, 0),
                    "Bronze 0": _.get(prop, `${valuePath}['Bronze 0']`, 0),
                    "Bronze 1": _.get(prop, `${valuePath}['Bronze 1']`, 0),
                    "Bronze 2": _.get(prop, `${valuePath}['Bronze 2+']`, 0),
                    Ouro: _.get(prop, `${valuePath}.Ouro`, 0),
                    Embaixador: _.get(prop, `${valuePath}.Embaixador`, 0)
                },
                period: "monthly"
            };
        });

        return _.sortBy(points, "t");
    }

    async populateHistoricBilling({ start, end }) {
        const { props } = await this.getHistoricBillingByDate({ start, end });

        const points = this._modelerPointsScore({
            data: props,
            s: "BILLING_ACCOUNTINGS",
            valuePath: "billingByAccountings"
        });

        this.PointsAccountingAnalytics.createMany(points);
    }

    async populateHistoricScore({ start, end }) {
        const { props } = await this.getHistoricScoreByDate({ start, end });

        const points = this._modelerPointsScore({
            data: props,
            s: "SCORE_ACCOUNTINGS",
            valuePath: "scoreByAccountings"
        });

        this.PointsAccountingAnalytics.createMany(points);
    }

    async populateHistoricImpact({ start, end }) {
        const { props } = await this.getHistoricImpactByDate({ start, end });

        const points = this._modelerPointsImpact({
            data: props,
            s: "IMPACT_ACCOUNTINGS",
            valuePath: "impactByStatus"
        });

        this.PointsAccountingAnalytics.createMany(points);
    }
}
